<template>
	<div class="basicTable agendaTable" v-if="getAgenda().length > 0">
		<div class="d-flex justify-content-end mb-1" v-if="conference?.request_translator">
			<TranslatorRequest :conference="conference" />
		</div>
		<table style="margin-top: unset !important">
			<thead>
				<tr>
					<th scope="col" v-if="!conference" v-t="'message.AgendaCard.conference'"></th>
					<th scope="col" v-t="'message.AgendaCard.student'"></th>
					<th scope="col" v-t="'message.AgendaCard.meeting_with'"></th>
					<th scope="col" v-t="'message.AgendaCard.date_time'"></th>
					<th scope="col" v-t="'message.AgendaCard.meeting_type'"></th>
					<th scope="col" v-t="'message.AgendaCard.location'"></th>
					<th
						scope="col"
						v-if="conference?.allow_comments"
						data-cy="agenda-comment-column"
						v-t="'message.AgendaCard.comment'"
					></th>
					<th scope="col" v-t="'message.AgendaCard.action'"></th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="appointment in getAgenda()" :key="appointment.pta_id">
					<td v-if="!conference" data-col="Conference: ">
						{{ appointment.conference_name }}
					</td>
					<td data-col="Student: ">{{ appointment.child_name }}</td>
					<td data-col="Meeting: ">{{ appointment.name }}</td>
					<td class="text-nowrap commaBlock" data-col="Date/Time: ">
						{{
							dayjs(appointment.timeslot).locale($i18n.locale).format("MMM Do, h:mm A")
						}}
					</td>
					<td data-col="Meeting Type: ">
						<MeetingType :appointment="appointment"></MeetingType>
					</td>
					<td data-col="Location: ">
						<MeetingLocation :appointment="appointment"></MeetingLocation>
					</td>
					<td v-if="!appointment.comment && conference?.allow_comments">
						<button
							class="btn btn-sm btn-outline-primary rounded"
							@click="showCommentModal(appointment)"
							data-cy="add-edit-comment-btn"
						>
							{{ $i18n.t("message.AgendaCard.add_comment") }}
						</button>
					</td>
					<td
						v-if="appointment.comment != null && conference && conference.allow_comments"
					>
						<div class="comment-preview">
							<p>{{ appointment.comment }}</p>
							<button
								class="btn btn-sm"
								title="edit comment"
								@click="showCommentModal(appointment)"
								data-cy="add-edit-comment-btn"
							>
								<i class="bi bi-pencil-fill text-primary"></i>
							</button>
							<!-- <button class="btn btn-sm" title="delete comment" @click="comment=null"><i class="bi bi-trash-fill text-primary"></i></button> -->
						</div>
					</td>
					<td>
						<div v-if="appointment.flag == 'R'">
							<button
								class="btn btn-sm btn-outline-primary rounded"
								:disabled="appointment.loading"
								@click="cancelMeeting(appointment)"
								:class="{ 'loading-spinner': appointment.loading }"
							>
								{{ $i18n.t("message.AgendaCard.delete") }}
							</button>
						</div>
						<div v-else>
							<i class="bi bi-link-45deg text-primary" style="font-size: 1.5rem;" title="Linked"></i>
						</div>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
	<ModalMeetingComment
		ref="myModal"
		:conference_id="conference.conference_id"
		v-if="conference && conference.allow_comments"
	></ModalMeetingComment>
</template>

<script setup>
import { ref } from "vue";
import dayjs from "dayjs";
import advancedFormat from "dayjs/esm/plugin/advancedFormat";
import ModalMeetingComment from "@/components/parent/modal/MeetingCommentModal.vue";
import MeetingType from "@/components/parent/MeetingType.vue";
import { useAgendaStore } from "@/stores/parent/agenda";
import MeetingLocation from "@/components/parent/MeetingLocation.vue";
import TranslatorRequest from "@/components/parent/TranslatorRequest.vue";

const agendaStore = useAgendaStore();
const props = defineProps({
	conference: Object,
});

const comment = ref(null);
const ptaId = ref(null);
const myModal = ref(null);
dayjs.extend(advancedFormat);

function showCommentModal(appointment) {
	comment.value = appointment.comment;
	ptaId.value = appointment.ptaId;
	myModal.value.show(appointment);
}
function getAgenda() {
	if (props.conference) {
		return agendaStore.agenda
			.filter((meeting) => meeting.conference_id == props.conference.conference_id)
			.sort((a, b) => {
				return a.start < b.start ? -1 : 1;
			});
	} else {
		return agendaStore.agenda;
	}
}

function cancelMeeting(meeting) {
	meeting.loading = true;
	agendaStore.cancelMeeting(meeting.pta_id).then((resp) => {
		if (resp) {
			let index = agendaStore.getMeetingIndexById(meeting.pta_id);
			agendaStore.agenda.splice(index, 1);
		} else {
			agendaStore.fetchAgenda().then(() => {
				console.log("Agenda Loaded");
			});
		}
		meeting.loading = false;
	});
}
</script>
<style scoped>
</style>
